module.exports = __webpack_public_path__ + "static/media/more-menu.d4ff16be.svg";